import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/visitador_medico/distribuidor';
import DistribuidorList from './DistribuidorList';


const ms2p = (state) => {
    return {
        ...state.vm_distribuidor,
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(DistribuidorList);
